import { useParams } from 'react-router-dom';

import { MilesText } from 'components';

import { getIsNew } from 'utils';

import { productStore } from '../../store';

export const Title = () => {
  const { productId } = useParams();

  const name = productStore((state) => state.initialValues.name);

  const isNew = getIsNew(productId);

  const title = isNew ? 'New Product' : `Product ${name}`;

  return (
    <MilesText
      size='xxl'
      className='font-medium'
    >
      {title}
    </MilesText>
  );
};
